import { render, staticRenderFns } from "./ConversationPanel.vue?vue&type=template&id=a99207a8&scoped=true"
import script from "./ConversationPanel.vue?vue&type=script&lang=js"
export * from "./ConversationPanel.vue?vue&type=script&lang=js"
import style0 from "./ConversationPanel.vue?vue&type=style&index=0&id=a99207a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99207a8",
  null
  
)

export default component.exports